import { useRef, useEffect, useCallback } from 'react';
import '../../utils/assertions.es.js';
import { callAllHandlers } from '../../utils/functions.es.js';
import { mergeRefs } from '../../utils/refs.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import { useDisclosure } from '../../hooks/useDisclosure/useDisclosure.es.js';
import 'react-beautiful-dnd';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const usePopover = ({
  isOpenDefault = false,
  onOpen: onOpenProp,
  onClose: onCloseProp,
  triggerEvent = "click",
  triggerRef,
  hasArrow,
  placement,
  closeOnBlur = true,
  closeDelay = 200
} = {}) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure({
    defaultIsOpen: isOpenDefault,
    onOpen: onOpenProp,
    onClose: onCloseProp
  });
  const isHoveringRef = useRef(false);
  const closeTimeout = useRef();
  const anchorRef = useRef(null);
  useEffect(() => {
    return () => {
      if (closeTimeout.current) {
        clearTimeout(closeTimeout.current);
      }
    };
  }, []);
  const getTriggerProps = useCallback(({ onClick = () => void 0, onMouseEnter = () => void 0, onMouseLeave = () => void 0 } = {}, forwardedRef = null) => {
    return __spreadProps(__spreadValues({}, !triggerRef && {
      onClick: triggerEvent === "click" ? callAllHandlers(onClick, onToggle) : onClick,
      onMouseEnter: triggerEvent === "hover" ? callAllHandlers(onMouseEnter, () => {
        isHoveringRef.current = true;
        onOpen();
      }) : onMouseEnter,
      onMouseLeave: triggerEvent === "hover" ? callAllHandlers(onMouseLeave, () => {
        isHoveringRef.current = false;
        closeTimeout.current = window.setTimeout(() => {
          if (isHoveringRef.current === false) {
            onClose();
          }
        }, closeDelay);
      }) : onMouseLeave
    }), {
      ref: mergeRefs(forwardedRef, anchorRef)
    });
  }, [closeDelay, onClose, onOpen, onToggle, triggerEvent, triggerRef]);
  const getPopoverProps = useCallback(({
    onMouseEnter = () => void 0,
    onMouseLeave = () => void 0
  } = {}) => {
    const handleClickOutside = () => {
      closeOnBlur && onClose();
    };
    return {
      anchorRef,
      isOpen,
      triggerRef,
      hasArrow,
      placement,
      onClickOutside: handleClickOutside,
      onMouseEnter: triggerEvent === "hover" ? callAllHandlers(onMouseEnter, () => {
        isHoveringRef.current = true;
      }) : onMouseEnter,
      onMouseLeave: triggerEvent === "hover" ? callAllHandlers(onMouseLeave, () => {
        isHoveringRef.current = false;
        closeTimeout.current = window.setTimeout(() => {
          if (isHoveringRef.current === false) {
            onClose();
          }
        }, closeDelay);
      }) : onMouseLeave
    };
  }, [closeDelay, closeOnBlur, hasArrow, isOpen, onClose, placement, triggerEvent, triggerRef]);
  return { isOpen, anchorRef, toggle: onToggle, open: onOpen, close: onClose, getTriggerProps, getPopoverProps };
};

export { usePopover };
//# sourceMappingURL=usePopover.es.js.map
